/* (ignored) */


//////////////////
// WEBPACK FOOTER
// fs (ignored)
// module id = 670
// module chunks = 1